import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ErrorMessageEffects } from './state/error-message.effects';
import * as fromReducer from './state/error-message.reducer';

@NgModule({
   imports: [
      StoreModule.forFeature(fromReducer.featureKey, fromReducer.errorMessageReducer),
      EffectsModule.forFeature([ErrorMessageEffects]),
   ],
})
export class ErrorMessageModule {}
